import axios from '../helpers/axiosConfig';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as Yup from 'yup';

function CreatGrade() {
  const navigate = useNavigate();

  const initialValues = {
    name: '',
    libelle: '',
    anneeretraite: '',
  };

  const validation = Yup.object().shape({
    name: Yup.string().min(3).max(100).required('Veuillez remplir ce champ '),
    libelle: Yup.string().min(1).max(255).required('Veuillez remplir ce champ '),
  });

  const enregistrer = (data) => {
    axios.post('/grade', data).then((res) => {
      console.log(res);
    });
    navigate('/grade');
  };
  return (
    <div className="container">
      <div>Nouveau Grade</div>
      <Formik initialValues={initialValues} onSubmit={enregistrer} validationSchema={validation}>
        <Form className="form-group">
          <div className="row">
            <div className="col">
              <label htmlFor="name"> Grade : </label>
              <ErrorMessage className="text-danger" name="name" component="span" />
              <Field id="name" name="name" className="form-control" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="libelle"> Libellé : </label>
              <ErrorMessage className="text-danger" name="libelle" component="span" />
              <Field id="libelle" name="libelle" className="form-control" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="anneeretraite"> Annee Retraite : </label>
              <ErrorMessage className="text-danger" name="anneeretraite" component="span" />
              <Field id="anneeretraite" name="anneeretraite" className="form-control" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <button className="btn btn-primary mt-4" type="submit">
                Enregistrer
              </button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default CreatGrade;
